module.exports = __webpack_public_path__ + "img/专利证书09_跨区域集团级建筑能源管理平台v1.0.2d7b07a9.png";